import { css } from '@emotion/css';

export const backgroundNavbar = css`
  background-color: transparent;
  font-size: 18px;
  font-family: 'Fuggles', cursive;
  max-width: 100%;
  behavior: smooth;
  scroll-behavior: smooth;

  .logo{
    float: left;
    text-align: center;
    width: 100%;
  }

  .navbar-brand{
    padding-top:0;
    padding-bottom:0;
  }

  .navbar{
    padding-top:0px;
    padding-bottom:0px;
  }

  .nav-link {
    align-self: center;
  }
  .pojokKiri{
    padding-left:1.5vw;
    font-family: 'Fuggles', cursive;
    font-size:calc(50px + 1vw);
    color:black;
    transition: font-size 0.2s;
  }

  .pojokKiri:hover {
    font-family: 'Fuggles', cursive;
    font-size:calc(70px + 1vw);
    color:black;
  }

  .nav-item {
    align-self: center;
  }

  .nav-link {
    padding-left: 2rem !important;
  }
`;